(function () {
  'use strict';

  if (window.ProductGroupCardSwatches) return;
  window.ProductGroupCardSwatches = true;

  var selectors = {
    card: '.js-product-item, .js-product, .scroll-item',
    group: '.js-product-group-card',
    item: '.product-group-item',
    link: '.js-product-group-card-link',
    data: '.js-product-group-card-data',
    list: '.product-group-list',
    indicator: '.js-product-group-card-indicator',
    indicatorBar: '.js-product-group-card-indicator-bar',
    image: '.product-item__image, .js-product-inline-image, .product-inline__image, .scroll-item__inner',
    title: '.product-item__title .link-inline, .product-inline__title .link-inline, .scroll-item__body .title-default',
    price: '.js-product-item-price, .js-product-price, .scroll-item__body > .price',
    badges: '.product-item__content > .product-badges-card, .product-item__content > .product-badges, .scroll-item__body > .product-badges-card, .scroll-item__body > .product-badges',
    select: '.js-product-item-select, .js-select-global, select[name="id"]',
    actionLinks: '.js-product-item-view, .js-product-item-details, .js-product-item-personalization, .js-product-details',
    submit: '.js-product-item-btn, .js-product-btn',
    productLinks: '.product-item__image a, .product-item__title a, .product-inline__image a, .product-inline__title a, .scroll-item > a, .scroll-item__inner a',
    bvRating: '[data-bv-show="inline_rating"]'
  };

  var mobileMediaQuery = window.matchMedia('(max-width: 767px)');
  var swatchGestureEvents = ['touchstart', 'touchmove', 'touchend', 'pointerdown', 'pointermove', 'pointerup', 'mousedown', 'mousemove', 'mouseup', 'dragstart'];
  var activeIndicatorDrag = null;

  function parseProductData(item) {
    var dataScript = item.querySelector(selectors.data);
    if (!dataScript) return null;

    try {
      return JSON.parse(dataScript.textContent);
    } catch (error) {
      console.warn('Unable to parse product group card data:', error);
      return null;
    }
  }

  function updateSelectedVariant(card, data) {
    var select = card.querySelector(selectors.select);
    if (!select || !data.variantId) return;

    var variantId = String(data.variantId);
    var option = select.querySelector('option[value="' + variantId + '"]');

    if (!option) {
      option = document.createElement('option');
      option.value = variantId;
      select.appendChild(option);
    }

    option.selected = true;
    option.disabled = !data.available;
    option.textContent = data.title;
    option.setAttribute('data-title', data.title);
    option.setAttribute('data-price', data.inlinePriceHtml || data.priceInnerHtml || data.priceHtml || '');
    select.setAttribute('data-title', data.title);
    select.setAttribute('data-product-id', data.id);
    select.value = variantId;
  }

  function updateAvailability(card, data) {
    var form = card.querySelector('form');
    var submit = card.querySelector(selectors.submit);

    card.classList.toggle('product-item--sold-out', !data.available);
    card.classList.toggle('scroll-item--sold-out', !data.available);
    card.classList.toggle('scroll-item--available', data.available);

    if (form) {
      form.classList.toggle('form-product-small--sold-out', !data.available);
      form.classList.toggle('form-product--sold-out', !data.available);
      form.classList.toggle('form-product-inline--sold-out', !data.available);
    }

    if (!submit) return;

    if ('value' in submit) {
      submit.value = data.submitLabel;
    }

    var submitLabel = submit.querySelector('span');
    if (submitLabel) {
      submitLabel.textContent = data.submitLabel;
    } else {
      submit.textContent = data.submitLabel;
    }

    submit.setAttribute('aria-label', data.submitLabel + ' - ' + data.title);
    submit.disabled = !data.available;
    submit.classList.toggle('blocked', !data.available);
    submit.toggleAttribute('aria-disabled', !data.available);
  }

  function refreshLazyImages(card) {
    var lazyImages = card.querySelectorAll('img.lazyload[data-src], img.lazyload[data-srcset]');

    lazyImages.forEach(function (img) {
      var dataSrc = img.getAttribute('data-src');
      var dataSrcset = img.getAttribute('data-srcset');
      var dataSizes = img.getAttribute('data-sizes');

      if (dataSrc) {
        img.src = dataSrc;
        img.removeAttribute('data-src');
      }

      if (dataSrcset) {
        img.srcset = dataSrcset;
        img.removeAttribute('data-srcset');
      }

      if (dataSizes) {
        img.sizes = dataSizes;
        img.removeAttribute('data-sizes');
      }
    });

    if (typeof LazyLoad !== 'undefined') {
      new LazyLoad({
        elements_selector: '.lazyload'
      });
    }
  }

  function normalizeInsertedImages(card, image) {
    if (!card.matches('.js-product') || card.matches('.js-product-item')) return;

    var figures = image.querySelectorAll('figure');
    if (!figures.length || image.querySelector('figure.expanded')) return;

    figures[0].classList.add('expanded');
  }

  function getPriceHtml(card, price, data) {
    if (card.matches('.js-product') && !card.matches('.js-product-item')) {
      return data.inlinePriceHtml || data.priceInnerHtml || data.priceHtml;
    }

    if (price && price.matches('.scroll-item__body > .price')) {
      return data.priceInnerHtml || data.priceHtml;
    }

    return data.priceHtml;
  }

  function getImageHtml(card, data) {
    if (card.matches('.scroll-item')) {
      return data.scrollImageHtml || data.imageHtml;
    }

    return data.imageHtml;
  }

  function stopSwatchGesturePropagation(event) {
    event.stopPropagation();
  }

  function updateSwatchIndicator(group) {
    var list = group.querySelector(selectors.list);
    var indicatorBar = group.querySelector(selectors.indicatorBar);

    if (!list || !indicatorBar || !mobileMediaQuery.matches) {
      group.classList.remove('has-swatch-overflow');
      return;
    }

    var maxScroll = list.scrollWidth - list.clientWidth;

    if (maxScroll <= 1) {
      group.classList.remove('has-swatch-overflow');
      indicatorBar.style.width = '';
      indicatorBar.style.left = '';
      return;
    }

    var barWidth = Math.max(18, (list.clientWidth / list.scrollWidth) * 100);
    var progress = list.scrollLeft / maxScroll;

    group.classList.add('has-swatch-overflow');
    indicatorBar.style.width = barWidth + '%';
    indicatorBar.style.left = (progress * (100 - barWidth)) + '%';
  }

  function updateAllSwatchIndicators() {
    document.querySelectorAll(selectors.group).forEach(updateSwatchIndicator);
  }

  function startSwatchIndicatorDrag(event) {
    var group = event.currentTarget.closest(selectors.group);
    var list = group ? group.querySelector(selectors.list) : null;
    var indicator = group ? group.querySelector(selectors.indicator) : null;
    var indicatorBar = group ? group.querySelector(selectors.indicatorBar) : null;

    if (!group || !list || !indicator || !indicatorBar || !mobileMediaQuery.matches) return;

    var maxScroll = list.scrollWidth - list.clientWidth;
    var trackRange = indicator.clientWidth - indicatorBar.offsetWidth;

    if (maxScroll <= 1 || trackRange <= 0) return;

    activeIndicatorDrag = {
      group: group,
      list: list,
      indicator: indicator,
      startX: event.clientX,
      startScroll: list.scrollLeft,
      maxScroll: maxScroll,
      trackRange: trackRange
    };

    indicator.classList.add('is-dragging');
    event.preventDefault();
    event.stopPropagation();

    if (typeof indicator.setPointerCapture === 'function' && event.pointerId != null) {
      indicator.setPointerCapture(event.pointerId);
    }
  }

  function dragSwatchIndicator(event) {
    if (!activeIndicatorDrag) return;

    var deltaX = event.clientX - activeIndicatorDrag.startX;
    var scrollDelta = (deltaX / activeIndicatorDrag.trackRange) * activeIndicatorDrag.maxScroll;

    activeIndicatorDrag.list.scrollLeft = activeIndicatorDrag.startScroll + scrollDelta;
    updateSwatchIndicator(activeIndicatorDrag.group);

    event.preventDefault();
    event.stopPropagation();
  }

  function stopSwatchIndicatorDrag(event) {
    if (!activeIndicatorDrag) return;

    activeIndicatorDrag.indicator.classList.remove('is-dragging');
    activeIndicatorDrag = null;

    if (event) {
      event.stopPropagation();
    }
  }

  function bindSwatchIndicator(group) {
    var list = group.querySelector(selectors.list);
    var indicator = group.querySelector(selectors.indicator);
    if (!list || !indicator || group.dataset.swatchIndicatorBound === 'true') return;

    group.dataset.swatchIndicatorBound = 'true';
    list.addEventListener('scroll', updateAllSwatchIndicators, { passive: true });
    indicator.addEventListener('pointerdown', startSwatchIndicatorDrag);
  }

  function unbindSwatchIndicator(group) {
    var list = group.querySelector(selectors.list);
    var indicator = group.querySelector(selectors.indicator);
    if (!list || !indicator || group.dataset.swatchIndicatorBound !== 'true') return;

    list.removeEventListener('scroll', updateAllSwatchIndicators);
    indicator.removeEventListener('pointerdown', startSwatchIndicatorDrag);
    indicator.classList.remove('is-dragging');
    delete group.dataset.swatchIndicatorBound;
    group.classList.remove('has-swatch-overflow');
  }

  function bindSwatchGestureGuards() {
    document.querySelectorAll(selectors.group).forEach(function (group) {
      bindSwatchIndicator(group);
      updateSwatchIndicator(group);

      if (group.dataset.swatchGestureGuard !== 'true') {
        group.dataset.swatchGestureGuard = 'true';

        swatchGestureEvents.forEach(function (eventName) {
          group.addEventListener(eventName, stopSwatchGesturePropagation, { passive: true });
        });
      }
    });
  }

  function unbindSwatchGestureGuards() {
    document.querySelectorAll(selectors.group).forEach(function (group) {
      unbindSwatchIndicator(group);

      if (group.dataset.swatchGestureGuard !== 'true') return;

      swatchGestureEvents.forEach(function (eventName) {
        group.removeEventListener(eventName, stopSwatchGesturePropagation);
      });

      delete group.dataset.swatchGestureGuard;
    });
  }

  function syncSwatchGestureGuards() {
    if (mobileMediaQuery.matches) {
      bindSwatchGestureGuards();
      return;
    }

    unbindSwatchGestureGuards();
  }

  function observeSwatchGroups() {
    if (!('MutationObserver' in window) || !document.body) return;

    var observer = new MutationObserver(syncSwatchGestureGuards);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function updateCard(card, data) {
    var image = card.querySelector(selectors.image);
    var title = card.querySelector(selectors.title);
    var price = card.querySelector(selectors.price);
    var badges = card.querySelector(selectors.badges);
    var bvRating = card.querySelector(selectors.bvRating);

    var imageHtml = getImageHtml(card, data);
    if (image && imageHtml) {
      image.innerHTML = imageHtml;
      normalizeInsertedImages(card, image);
    }

    if (title) {
      if (title.matches('a')) {
        title.href = data.url;
      }
      title.textContent = data.title;
    }

    var priceHtml = price ? getPriceHtml(card, price, data) : null;
    if (price && priceHtml) {
      price.innerHTML = priceHtml;
    }

    if (badges && data.badgesHtml) {
      badges.outerHTML = data.badgesHtml;
    }

    card.querySelectorAll(selectors.actionLinks).forEach(function (link) {
      link.href = data.url;
    });

    card.querySelectorAll(selectors.productLinks).forEach(function (link) {
      if (link.closest(selectors.group)) return;
      link.href = data.url;
    });

    if (bvRating) {
      bvRating.setAttribute('data-bv-product-id', data.id);
      bvRating.setAttribute('data-bv-redirect-url', window.location.origin + data.url);
    }

    updateSelectedVariant(card, data);
    updateAvailability(card, data);
    refreshLazyImages(card);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(selectors.link);
    if (!link) return;

    var group = link.closest(selectors.group);
    var card = link.closest(selectors.card);
    var item = link.closest(selectors.item);
    var data = item ? parseProductData(item) : null;

    if (!group || !card || !item || !data) return;

    event.preventDefault();

    group.querySelectorAll(selectors.item).forEach(function (groupItem) {
      groupItem.classList.remove('active');
    });
    item.classList.add('active');

    card.classList.add('product-item--group-loading');
    updateCard(card, data);

    window.requestAnimationFrame(function () {
      card.classList.remove('product-item--group-loading');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSwatchGestureGuards);
  } else {
    syncSwatchGestureGuards();
  }

  document.addEventListener('shopify:section:load', syncSwatchGestureGuards);
  document.addEventListener('pointermove', dragSwatchIndicator, true);
  document.addEventListener('pointerup', stopSwatchIndicatorDrag, true);
  document.addEventListener('pointercancel', stopSwatchIndicatorDrag, true);
  window.addEventListener('resize', updateAllSwatchIndicators);

  if (typeof mobileMediaQuery.addEventListener === 'function') {
    mobileMediaQuery.addEventListener('change', syncSwatchGestureGuards);
  } else if (typeof mobileMediaQuery.addListener === 'function') {
    mobileMediaQuery.addListener(syncSwatchGestureGuards);
  }

  observeSwatchGroups();
})();
